import React, { KeyboardEvent } from 'react';
import { useChatWidgetContext } from '../../ChatWidgetContext';
import styles from '../ChatWidget.module.scss';

export default function MessageInput() {
  const { sendMessage, isStreaming, inputText, setInputText } = useChatWidgetContext();

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  return (
    <div className={styles.inputContainer}>
      <input
        type="text"
        className={styles.inputField}
        placeholder="Ask anything..."
        value={inputText}
        onChange={(e) => setInputText(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={isStreaming}
        data-testid="chat-message-input"
      />
      <button
        type="button"
        className={styles.sendButton}
        onClick={sendMessage}
        disabled={isStreaming || !inputText.trim()}
        data-testid="chat-send-button"
      >
        SEND &#9654;
      </button>
    </div>
  );
}
